/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_File_Student_2_NameInputs */

const da_forside_file_student_2_name = /** @type {(inputs: Forside_File_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besvarelse, elev 2`)
};

/** @type {(inputs: Forside_File_Student_2_NameInputs) => LocalizedString} */
const en_forside_file_student_2_name = da_forside_file_student_2_name;

/**

* @param {Forside_File_Student_2_NameInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_file_student_2_name = /** @type {((inputs?: Forside_File_Student_2_NameInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_File_Student_2_NameInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_file_student_2_name(inputs)
	return /** @type {LocalizedString} */ ("Besvarelse, elev 2")
});